import React from 'react'

import './styles.scss'
import TranslationItem from '../TranslationItem'
import { Button } from 'components/Form'
import { lang } from 'utils/helpers'

const ResultsSection = props => {
  const {
    filters, setFilters, getTranslations, translations,
    setTranslations, labelsOptions, loading, isAllTranslations
  } = props

  const handleLoadMore = () => {
    const updatedFilters = { ...filters }
    updatedFilters.page = updatedFilters.page + 1
    setFilters(updatedFilters)
    getTranslations(updatedFilters)
  }

  return (
    <div className='translations-translations-section-results'>
      {translations.map(translation => (
        <TranslationItem
          key={translation._id}
          id={translation._id}
          tag={translation.tag}
          platform={translation.platform}
          labels={translation.labels}
          localeDisplay={filters.locale}
          textDefault={translation.byDefault}
          text={translation.text}
          date={translation.lastModifiedAt || translation.createdAt}
          translations={translations}
          setTranslations={setTranslations}
          labelsOptions={labelsOptions}
        />
      ))}
      {(loading || !isAllTranslations) ? (
        <Button
          clearPrimary
          value={lang('dashboard_load-more')}
          onClick={handleLoadMore}
          isSubmitting={loading}
        />
      ) : null}
      {!loading && !translations.length ? (
        <p className='translations-translations-section-results__info-text'>
          {lang('dashboard_no-translations')}
        </p>
      ) : null}
    </div>
  )
}

export default ResultsSection
